// extracted by mini-css-extract-plugin
module.exports = {"vip-only-popup__icon":"style_vip-only-popup__icon__W9ZrZ","vip-only-popup__description":"style_vip-only-popup__description__vLt_h"};